import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DialogShellComponent } from '../dialog-shell/dialog-shell.component';

export interface ConfirmWarningDialogData {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
}

@Component({
  selector: 'xemex-confirm-warning-dialog',
  standalone: true,
  imports: [DialogShellComponent, MatButtonModule, MatDialogModule, MatIconModule],
  templateUrl: './confirm-warning-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmWarningDialogComponent {
  readonly data = inject(MAT_DIALOG_DATA) as ConfirmWarningDialogData;
}
